function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.function.bind.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.create.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.get-prototype-of.js";
import "core-js/modules/es.object.set-prototype-of.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.reflect.construct.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
import Collapse from './collapse/_collapse';
var EXPANDABLECLASS = 'is-expandable';
var SHOWMORECLASS = {
  link: 'mc-link'
};
var ShowMore = /*#__PURE__*/function (_Collapse) {
  function ShowMore(options) {
    var _this;
    _classCallCheck(this, ShowMore);
    _this = _callSuper(this, ShowMore, [options.id]);
    _this.options = options;
    _this.container = document.getElementById(_this.options.id);
    _this.init();
    return _this;
  }
  _inherits(ShowMore, _Collapse);
  return _createClass(ShowMore, [{
    key: "init",
    value: function init() {
      this.container.classList.add(EXPANDABLECLASS);
      this.container.nextSibling.ariaExpanded = false;
      this.container.style.maxHeight = this.options.initialHeight;
      var btn = _initButton.call(this);
      this.container.parentNode.insertBefore(btn, this.container.nextSibling);
      btn.addEventListener('click', _toggleButton.bind(this));
    }
  }]);
}(Collapse);
export default ShowMore;
function _toggleButton(e) {
  if (!e.target.classList.contains(SHOWMORECLASS.link)) return;
  e.preventDefault();
  var action = this.container.classList.contains(EXPANDABLECLASS) ? 'less' : 'more';
  var labelBtn = action === 'less' ? this.options.label.less : this.options.label.more;
  this.container.nextSibling.ariaExpanded = action !== 'more';
  e.target.innerHTML = _generateShowMoreButtonContent(labelBtn, action !== 'more');
  this.container.classList.toggle(EXPANDABLECLASS);
  this.container.style.maxHeight = action === 'more' ? this.options.initialHeight : null;
}
function _initButton() {
  var btn = document.createElement('button');
  btn.setAttribute('aria-controls', this.options.id);
  btn.classList.add(SHOWMORECLASS.link);
  if (this.options.cssClass) {
    btn.classList.add(this.options.cssClass);
  }
  btn.innerHTML = _generateShowMoreButtonContent(this.options.label.more, false);
  return btn;
}
function _generateShowMoreButtonContent(label, isExpanded) {
  var icon = isExpanded ? 'Navigation_Arrow_Arrow--Top_16px' : 'Navigation_Arrow_Arrow--Bottom_16px';
  return "".concat(label, " <svg class=\"mc-link__icon mc-link__icon--right\" aria-hidden=\"true\">\n    <use href=\"#").concat(icon, "\"></use>\n  </svg>");
}